class InvestmentPage {
    constructor() {
        this.init_selection_listener();
        this.wedding_packages = ['highlight_reel','feature_film'];
    }

    init_selection_listener() {
        document.querySelectorAll('.radio_price_button').forEach(v => {
            v.addEventListener('click', this.handle_selections.bind(this));
        });
    }

    handle_selections(e) {
        const radio = e.target;
        const $add_ons = document.querySelector('[name=add_ons]');

        const add_addon = (addon) => {
            const current_value = $add_ons.value;
            if (current_value !== '') {
                try {
                    let current_addons = JSON.parse(current_value);
                    if (!current_addons.includes(addon)) current_addons.push(addon);
                    $add_ons.value = JSON.stringify(current_addons);
                } catch (e) {
                    console.log("Failed to get/add addons.", e);
                }
            } else {
                $add_ons.value = JSON.stringify([addon]);
            }
        }

        const remove_addon = (addon) => {
            const current_value = $add_ons.value;
            if (current_value !== '') {
                try {
                    let current_addons = JSON.parse(current_value);
                    let index = current_addons.indexOf(addon);
                    if (index !== -1) {
                        current_addons.splice(index, 1);
                    }
                    if (current_addons.length === 0) return $add_ons.value = '';
                    $add_ons.value = JSON.stringify(current_addons);
                } catch (e) {
                    console.log("Failed to get/remove addons.", e);
                }
            }
        }

        // If someone is clicking a selected item, remove it's selected-ness
        if (radio.classList.contains('selected')) {
            radio.classList.remove('selected');

            // If un-selecting an add-on, remove add-on from hidden from field
            if ('addOn' in radio.dataset) remove_addon(radio.dataset.addOn);

            // If un-selecting a wedding package, un-select all add-on's as well.
            // if ('projectType' in radio.dataset && this.wedding_packages.includes(radio.dataset.projectType)) {
            //     document.querySelectorAll('#wedding_add_ons .radio_price_button').forEach(v => v.classList.remove('selected'));
            //     $add_ons.value = '';
            // }
            return;
        }

        // If all someone is doing is selecting an add-on, just select it
        // and move on. There's nothing else to do.
        if ('addOn' in radio.dataset) {
            add_addon(radio.dataset.addOn);
            return radio.classList.add('selected');
        }

        // Toggle the selected-ness
        document.querySelectorAll('.radio_price_button').forEach(v => {
            // Don't toggle add-ons
            if ('addOn' in v.dataset) return;
            v.classList.remove('selected');
        });

        // If someone chooses a non-wedding package, un-select wedding add-ons
        if ($('#contact_us_form')) { // Ignore on collections contact form
            if ('projectType' in radio.dataset && !this.wedding_packages.includes(radio.dataset.projectType)) {
                document.querySelectorAll('#wedding_add_ons .radio_price_button').forEach(v => v.classList.remove('selected'));
                $add_ons.value = '';
            }
        }

        // Select the clicked radio button
        radio.classList.add('selected');

        // Set the project type and specific type in the contact form
        const project_type = radio.dataset.projectType || 'other';
        const project_type_map = {
            wedding: ['highlight_film','feature_film','custom_wedding','w_undecided','elopement'],
            commercial: ['corporate_event','promo','social_media','tv','c_other'],
            family: ['birth_story','party','lifestyle','f_other','day_of_birth'],
            other: ['other'],
        };
        let btn = 'other';
        for (let i in project_type_map) {
            if (project_type_map[i].includes(project_type)) {
                btn = i;
                break;
            }
        }
        const $btn = document.getElementById(`${btn}_btn`);
        if ($btn) $btn.click();
        if (project_type !== 'other') document.querySelector('[name=specific_type]').value = project_type;
    }

    jump_to_section(hash) {
        // console.log("Filtering by: ", hash);
        if (!hash) return;
        const section = document.getElementById(hash.replace(/^#/, ''));
        if (!section) return;
        const section_top = section.offsetTop || null;
        if (!section_top) return;
        window.scrollTo({
            top: section_top - 70,
            behavior: "smooth",
        });
    }
}

let investment_page;
document.addEventListener("DOMContentLoaded", () => {
    investment_page = new InvestmentPage();
});
